/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { ServizioMensaStudenteDiscoveryDTO } from '../model/servizio-mensa-studente-discovery-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    StudentiCittadinoServiceInterface,
    ListStudentiMensaCittadinoRequestParams
} from './studenti-cittadino.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class StudentiCittadinoService extends BaseService implements StudentiCittadinoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Lista degli studenti del cittadino sul servizio scelto.
     * Header servizio + gate Pratica-accettata. Ritorna i propri studenti sul servizio (DTO leggero: id, nome, cognome, scuola, sospeso, esente). Nessuno studente accessibile → 404.
     * @endpoint get /api/v1/cittadino/servizi/mensa/studenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listStudentiMensaCittadino(requestParameters: ListStudentiMensaCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaStudenteDiscoveryDTO>>;
    public listStudentiMensaCittadino(requestParameters: ListStudentiMensaCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaStudenteDiscoveryDTO>>>;
    public listStudentiMensaCittadino(requestParameters: ListStudentiMensaCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaStudenteDiscoveryDTO>>>;
    public listStudentiMensaCittadino(requestParameters: ListStudentiMensaCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listStudentiMensaCittadino.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/studenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaStudenteDiscoveryDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
